/*
 * Cart Progress Bar (.cpb-*) — Soosmarts aurum
 * Listens to PUB_SUB_EVENTS.cartUpdate (published by product-form.js on every
 * add — works in notification mode), re-fetches /cart.js for an authoritative
 * total. Fill staggered ~950ms after the cart bounce (component-cart-bounce.css
 * = 0.95s). Celebration fires once per crossing. THRESHOLD FIELD provisional —
 * diagnostic prints all three cart fields so the qualifying field is verified.
 */
function initCpb() {
  const root = document.querySelector('[data-cpb]');
  if (!root) return;
  // Idempotency: repeated section:load events re-run initCpb; without this
  // each run adds another cartUpdate subscription + /cart.js fetch. A
  // customizer re-render replaces the element, so a fresh one has no marker.
  if (root.dataset.cpbInit === '1') return;
  root.dataset.cpbInit = '1';

  const FILL_DELAY_MS = parseInt(root.dataset.cpbFillDelay, 10) || 950;
  const CELEBRATE_DELAY_MS = parseInt(root.dataset.cpbCelebrateDelay, 10) || 300;
  const THRESHOLD_CENTS = parseInt(root.dataset.cpbThreshold, 10) || 0;
  const QTY_FIELD = root.dataset.cpbField || 'original_total_price';
  const DIAGNOSTIC = root.dataset.cpbDiagnostic === 'true';

  const fillEl = root.querySelector('[data-cpb-fill]');
  const msgEl = root.querySelector('[data-cpb-msg]');
  const utilityBar = root.closest('.utility-bar');

  const msgBelow = root.dataset.cpbMsgBelow || 'Spend [remaining] more for [label]';
  const msgUnlocked = root.dataset.cpbMsgUnlocked || '[label] unlocked!';
  const discountLabel = root.dataset.cpbLabel || '10% off';

  let celebrated = false;
  const formatMoney = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');

  const renderState = (qtyCents, animate) => {
    if (THRESHOLD_CENTS <= 0) return;
    const hasItems = qtyCents > 0;
    if (utilityBar) utilityBar.classList.toggle('cpb-active', hasItems);
    if (!hasItems) return;

    const pct = Math.min(100, Math.round((qtyCents / THRESHOLD_CENTS) * 100));
    const remaining = Math.max(0, THRESHOLD_CENTS - qtyCents);
    const unlocked = qtyCents >= THRESHOLD_CENTS;

    const applyFill = () => { if (fillEl) fillEl.style.width = pct + '%'; };
    if (animate) setTimeout(applyFill, FILL_DELAY_MS); else applyFill();

    if (msgEl) {
      if (unlocked) {
        msgEl.innerHTML = msgUnlocked.replace('[label]', discountLabel);
        root.classList.add('cpb--unlocked');
      } else {
        msgEl.innerHTML = msgBelow
          .replace('[remaining]', '<strong>' + formatMoney(remaining) + '</strong>')
          .replace('[label]', '<strong>' + discountLabel + '</strong>');
        root.classList.remove('cpb--unlocked');
      }
    }
  };

  const celebrate = () => {
    if (celebrated) return;
    celebrated = true;
    setTimeout(() => {
      root.classList.add('cpb--celebrate');
      setTimeout(() => root.classList.remove('cpb--celebrate'), 1400);
    }, FILL_DELAY_MS + CELEBRATE_DELAY_MS);
  };

  let prevQty = 0;

  const refresh = (animate) => {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const qty = cart[QTY_FIELD];
        if (DIAGNOSTIC) {
          console.log('[cpb] /cart.js →', {
            total_price: cart.total_price,
            items_subtotal_price: cart.items_subtotal_price,
            original_total_price: cart.original_total_price,
            using: QTY_FIELD, value: qty, threshold: THRESHOLD_CENTS,
          });
        }
        if (typeof qty !== 'number') return;
        const crossed = prevQty < THRESHOLD_CENTS && qty >= THRESHOLD_CENTS;
        renderState(qty, animate);
        if (crossed) celebrate();
        prevQty = qty;
      })
      .catch(() => {});
  };

  // Seed initial state from /cart.js (no animation). Replaces the old
  // Liquid data-cpb-initial so the section no longer references `cart`
  // (which the customizer rejected as a dynamic-source error).
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      const qty = cart[QTY_FIELD];
      if (typeof qty === 'number') {
        if (qty >= THRESHOLD_CENTS && THRESHOLD_CENTS > 0) celebrated = true;
        renderState(qty, false);
        prevQty = qty;
      }
    })
    .catch(() => {});

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh(true));
  } else {
    document.addEventListener('cart:updated', () => refresh(true));
  }
}

// Run on initial load and re-bind on every customizer section render (audit A+B).
if (document.readyState !== 'loading') initCpb();
else document.addEventListener('DOMContentLoaded', initCpb);
document.addEventListener('shopify:section:load', initCpb);

